import React, { useRef, useState } from 'react'
import { useApplicationContext } from '../../contexts/appContext'
import { ErrorDialog, LoadingDialog, Header, Layout } from '@verifier-user/verifier-cdr'
import { EastVenturesSuccess } from './EastVenturesSuccess'
import { IncomeSuccess } from './IncomeSuccess'
import { EnergySuccess } from './EnergySuccess'
import { AngleSuccess } from './AngleSuccess'
import { SolarAssessSuccess } from './SolarAssessSuccess'
import { BavSuccess } from './BavSuccess'
import { VerifierConnectSuccess } from './VerifierConnectSuccess'

export const Success = () => {
  const [error, setError] = useState(null)
  const [errorShown, setErrorShown] = useState(false)
  const [processing, setProcessing] = useState(false)
  const containerRef = useRef(null)
  const currentErrorRef = useRef(null)

  const { vendorSettings, vendorData, logout } = useApplicationContext()

  const components = {
    SolarAssessSuccess,
    EastVenturesSuccess,
    IncomeSuccess,
    EnergySuccess,
    AngleSuccess,
    BavSuccess,
    VerifierConnectSuccess
  }

  const getSuccessComponent = () => {
    const SuccessComponent = components[vendorData.successComponent]
    return (
      <SuccessComponent
        currentErrorRef={currentErrorRef}
        setProcessing={setProcessing}
        setError={setError}
        setErrorShown={setErrorShown}
      />
    )
  }

  return (
    <>
      <Header vendorSettings={vendorSettings} />
      <Layout
        vendorSettings={vendorSettings}
        isAuthenticated={() => {
          return false
        }}
        logout={logout}
      >
        <div ref={containerRef}>
          <LoadingDialog id={'fnf-success'} isOpen={processing} />

          <ErrorDialog
            id='successDialog'
            error={error}
            open={errorShown}
            setOpen={setErrorShown}
            cancelHandler={currentErrorRef.current && currentErrorRef.current.cancelFunction}
            okTitle={
              currentErrorRef.current && currentErrorRef.current.okTitle ? currentErrorRef.current.okTitle : 'Ok'
            }
            cancelTitle={
              currentErrorRef.current && currentErrorRef.current.cancelTitle
                ? currentErrorRef.current.cancelTitle
                : 'Cancel'
            }
            retryHandler={currentErrorRef.current ? currentErrorRef.current.retryFunction : undefined}
          />

          {getSuccessComponent()}
        </div>
      </Layout>
    </>
  )
}
